import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { useConfig } from '../../config/context';

export function useFormatters() {
  const config = useConfig();

  return {
    formatTime(iso: string): string {
      return format(parseISO(iso), config.FORMAT.TIME);
    },
    formatDate(iso: string): string {
      return format(parseISO(iso), config.FORMAT.DATE);
    },
  };
}
